import React, { useRef, useState } from "react";
import { api } from "./lib/api";

// المصدر الوحيد في المستودع لرأس صورة قوالب واتساب:
//   • تحقق قيود ميتا (JPEG/PNG · ≤5MB) — لا يُكرَّر في أي مكان آخر.
//   • رفع الصورة إلى ميتا للحصول على header_handle (Resumable Upload، صالح ~24h).
// يُستهلَك في: CreateTemplateModal (استبيانات/استهداف) ومحرر القوالب AI (مركز التواصل).
// props: file (File|null) · onChange(File|null) · testidPrefix
const MAX = 5 * 1024 * 1024;
const OK_TYPES = ["image/jpeg", "image/png"];

// رفع مقبض رأس الصورة — الاستدعاء الوحيد لـ /whatsapp/templates/header-image.
export async function uploadHeaderImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const up = await api.post("/whatsapp/templates/header-image", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return up.data?.handle || null;
}

export default function HeaderImageField({ file, onChange, testidPrefix = "header-image" }) {
  const [err, setErr] = useState("");
  const inputRef = useRef(null);

  const onFile = (e) => {
    const f = e.target.files?.[0];
    setErr("");
    if (!f) { onChange(null); return; }
    if (!OK_TYPES.includes(f.type)) {
      setErr("يقبل ميتا JPEG أو PNG فقط لرأس القالب."); onChange(null); return;
    }
    if (f.size > MAX) {
      setErr("حجم الصورة يتجاوز 5MB (الحد الأقصى لدى ميتا)."); onChange(null); return;
    }
    onChange(f);
  };

  const lbl = { display: "block", fontSize: 12, fontWeight: 700, color: "#57534E", marginBottom: 4 };

  return (
    <div data-testid={`${testidPrefix}-block`}
      style={{ display: "grid", gap: 6, padding: 10, background: "#F0F7FF", borderRadius: 10, border: "1px solid #BFDBFE" }}>
      <label style={lbl}>🖼️ رأس صورة (اختياري) — JPEG/PNG فقط · ≤ 5MB</label>
      {/* زر مرئي يشغّل المدخل — لأن index.css يضبط input[type=file]{display:none} عالميًا */}
      <button type="button" data-testid={`${testidPrefix}-pick`}
        onClick={() => inputRef.current?.click()}
        style={{ justifySelf: "start", fontSize: 12, fontWeight: 700, color: "#1D4ED8",
          background: "#fff", border: "1px solid #BFDBFE", borderRadius: 8, padding: "6px 12px", cursor: "pointer" }}>
        📎 {file ? "تغيير الصورة" : "اختر صورة"}
      </button>
      <input ref={inputRef} data-testid={`${testidPrefix}-file`} type="file" accept="image/jpeg,image/png"
        onChange={onFile} style={{ display: "none" }} />
      {err && (
        <div data-testid={`${testidPrefix}-error`} style={{ fontSize: 11, color: "#B91C1C", fontWeight: 700 }}>⚠ {err}</div>
      )}
      {file && !err && (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <img data-testid={`${testidPrefix}-preview`} src={URL.createObjectURL(file)} alt="preview"
            style={{ width: 54, height: 54, objectFit: "cover", borderRadius: 8, border: "1px solid #BFDBFE" }} />
          <span style={{ fontSize: 11, color: "#1D4ED8" }}>{file.name} · ستُرفع عند التقديم (المقبض صالح ~24 ساعة)</span>
        </div>
      )}
    </div>
  );
}
